<p-toast position="bottom-left"></p-toast>
<p-confirmDialog styleClass="confirm-dialog"></p-confirmDialog>

<div class="add-code-container py-6 bg-white" aria-labelledby="add-code-title">
  <div class="add-code-header flex items-center h-12 px-4 mb-0 rounded-t">
    <h1 id="add-code-title" class="text-sm font-semibold m-0">{{ isExistingCode ? 'Edit Code' : 'Add Code' }}</h1>
  </div>

  <div class="add-code-form p-6 rounded-b">
    <!-- Code Information Component -->
    <app-code-information
      class="block mb-6"
      [mode]="'add'"
      [hcpcsCodeData]="editingCode"
      (formChange)="onCodeInfoChange($event)"
      (codeSelected)="onCodeSelected($event)"
      (clinicalFormsLoaded)="onClinicalFormsLoaded($event)"
      (modifiersLoaded)="onModifiersLoaded($event)"
      (save)="onSave($event)">
    </app-code-information>

    <!-- HCPCS Modifiers Component -->
    <app-modifiers
      *ngIf="showModifiers"
      class="block mb-6"
      [mode]="'add'"
      [initialModifiers]="modifiersData"
      [cmsEffectiveStartDate]="cmsEffectiveStartDate"
      [cmsEffectiveEndDate]="cmsEffectiveEndDate"
      [planEffectiveStartDate]="planEffectiveStartDate"
      [planEffectiveEndDate]="planEffectiveEndDate"
      [tenantId]="tenantId"
      (initialLoadComplete)="onModifiersInitialLoadComplete()">
    </app-modifiers>

    <!-- Clinical Questionnaire Forms Component -->
    <app-clinical-questionnaire-forms
      *ngIf="showClinicalForms"
      class="block mb-6"
      [mode]="'add'"
      [isVisible]="true"
      [initialForms]="clinicalFormsData"
      [cmsEffectiveStartDate]="cmsEffectiveStartDate"
      [planEffectiveStartDate]="planEffectiveStartDate"
      [tenantId]="tenantId"
      (initialLoadComplete)="onClinicalFormsInitialLoadComplete()">
    </app-clinical-questionnaire-forms>  

    <!-- Form Actions -->
    <div class="flex flex-col sm:flex-row gap-3 justify-end pt-4 mt-6" role="group" aria-label="Form actions">
      <button 
        type="button"
        pButton
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        class="w-full sm:w-auto"
        aria-label="Cancel and return to code list"
        (click)="onCancel()">
      </button>
      <button 
        type="button"
        pButton
        label="Save"
        class="w-full sm:w-auto"
        [disabled]="!isFormValid"
        [attr.aria-disabled]="!isFormValid"
        aria-label="Save code information"
        (click)="onSaveClick()">
      </button>
    </div>
  </div>
</div>

<!-- Unsaved Changes Modal -->
<p-dialog 
  [(visible)]="showUnsavedChangesModal"
  [modal]="true"
  [closable]="true"
  [style]="{width: '450px'}"
  header="Unsaved Changes"
  role="alertdialog"
  aria-label="Unsaved Changes"
  aria-describedby="unsaved-changes-description">
  <p id="unsaved-changes-description">You have unsaved changes that will be lost. Are you sure you want to leave this page?</p>
  <ng-template pTemplate="footer">
    <button 
      type="button"
      pButton
      label="Back"
      class="p-button-secondary"
      aria-label="Go back to form"
      (click)="backToForm()">
    </button>
    <button 
      type="button"
      pButton
      label="Discard Changes"
      class="p-button-danger"
      aria-label="Discard changes and leave page"
      (click)="confirmDiscard()">
    </button>
  </ng-template>
</p-dialog>
